import { ICreateSendEmailState } from '../types/createSendEmail';
import { IStepBlockingAction } from '../types/createSendFlow';
import { EmailTemplateTypesEnum } from '../types/templates';
import { TEMPLATE_TOKENS } from './templates';

export const DEFAULT_CREATE_SEND_EMAIL_STATE: ICreateSendEmailState = {
  initialized: false,
  emailTemplateId: null,
  subject: '',
  body: '',
  previousTemplateId: null,
  reminder: { interval: '', intervalDraft: null, customDaysDraft: null },
};

/**
 * Font colours offered in the email composer. These are inlined into the outgoing email HTML,
 * so they are fixed hex values on purpose — never derived from the live theme, otherwise a
 * white-label palette override would silently recolour mail.
 */
export const EMAIL_FONT_COLOR_OPTIONS: readonly string[] = [
  '#212121',
  '#5F11EA',
  '#0288D1',
  '#2E7D32',
  '#C62828',
  '#ED6C02',
];

export const DIGITAL_GIFT_URLS_TOKEN = `[${TEMPLATE_TOKENS.DigitalGiftURLs}]`;
export const DELAYED_SHIPPING_URLS_TOKEN = `[${TEMPLATE_TOKENS.DelayedShippingURLs}]`;

export const EMAIL_TEMPLATE_TYPE_BY_TOKEN: Record<string, EmailTemplateTypesEnum> = {
  [DIGITAL_GIFT_URLS_TOKEN]: EmailTemplateTypesEnum.DIGITAL_GIFT,
  [DELAYED_SHIPPING_URLS_TOKEN]: EmailTemplateTypesEnum.DELAYED_SHIPPING,
};

export const requiredEmailTokenMessage = (token: string): string => `Your email text must contain ${token} token`;

export const insertEmailTokenLabel = (token: string): string =>
  token === DIGITAL_GIFT_URLS_TOKEN ? 'Insert gift link' : 'Insert claim link';

export const emailTokenBlockAction = (token: string): IStepBlockingAction => ({
  label: insertEmailTokenLabel(token),
  target: 'email-token',
});
